import React from 'react'
// components
import TableManagementProvider from 'containers/Search/layers/BL'
import Users from 'components/PageComponents/Settings/Users/Register'
import UsersPageAPI from './layers/API'

const UsersContainer: React.FC = () => (
  <TableManagementProvider initialFilter={{ active: true }}>
    <UsersPageAPI>
      <Users />
    </UsersPageAPI>
  </TableManagementProvider>
)

export default UsersContainer
